import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import StoreInfo from '../components/store-info/StoreInfo';
import ProductList from '../components/products/ProductList';
import { useProductStore } from '../store/useProductStore';
import { useStoreInfo } from '../store/useStoreInfo';

/**
 * صفحة منتج واحدة - لدعم روابط SEO من sitemap (/product/:id)
 * تعرض الصفحة الرئيسية وتفتح تفاصيل المنتج تلقائياً عند التطابق.
 */
const ProductPage = () => {
  const { id } = useParams<{ id: string }>();
  const { products, fetchProducts } = useProductStore();
  const storeName = useStoreInfo((s) => s.data?.name) || 'اطلب';

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  // تحديث عنوان الصفحة عند تحميل المنتج (ديناميكي حسب اسم المتجر)
  useEffect(() => {
    if (!id || products.length === 0) return;
    const productId = parseInt(id, 10);
    if (Number.isNaN(productId)) return;
    const product = products.find((p) => p.id === productId);
    if (product) {
      document.title = `${product.title} - ${storeName}`;
    }
  }, [id, products, storeName]);

  return (
    <>
      <StoreInfo />
      <ProductList openProductId={id} />
    </>
  );
};

export default ProductPage;
